import { Icon } from '@branch-messenger/willow-ui'
import {
  CreditCard02,
  HelpCircle,
  LogOut01,
  UserCircle,
} from '@branch-messenger/willow-ui/icons'
import { linkOptions } from '@tanstack/react-router'

import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownSeparator,
} from '@/components/dropdown-menu'
import { DropdownMenuGroup } from '@/components/dropdown-menu/styles'
import { supportUrl } from '@/lib/urls'
import { useLogout } from '@/queries/auth'
import { type FileRoutesByTo } from '@/routeTree.gen'

import { AccountDropdownUserInfo } from './AccountDropdownUserInfo'

export type ValidRoutes = keyof FileRoutesByTo

const menuItems = linkOptions([
  {
    to: '/account/personalInfo',
    icon: UserCircle,
    title: 'Account Info',
  },
  {
    to: '/account/connectedDebitCards',
    icon: CreditCard02,
    title: 'Connected Debit Cards',
  },
])

export const AccountDropdown = () => {
  const logout = useLogout()
  const isAccountRoute = location.pathname.includes('/account')

  const handleLogout = () => logout.mutate()

  return (
    <DropdownMenu
      trigger={<DropdownMenuTrigger Icon={UserCircle} />}
      showArrow={false}
    >
      {isAccountRoute && (
        <>
          <AccountDropdownUserInfo />
          <DropdownSeparator />
          <DropdownMenuGroup>
            {menuItems.map(({ icon, ...item }) => (
              <DropdownMenuItem
                key={item.to}
                iconLeft={<Icon Icon={icon} />}
                showArrowRight={false}
                titleSize="xs"
                {...item}
              />
            ))}
          </DropdownMenuGroup>
          <DropdownSeparator />
        </>
      )}
      <DropdownMenuGroup>
        <DropdownMenuItem
          href={supportUrl}
          target="_blank"
          rel="noreferrer"
          iconLeft={<Icon Icon={HelpCircle} />}
          showArrowRight={false}
          title={'Help Center'}
          titleSize="xs"
        />
        {isAccountRoute && (
          <DropdownMenuItem
            onClick={handleLogout}
            iconLeft={<Icon Icon={LogOut01} />}
            showArrowRight={false}
            title={'Sign Out'}
            titleSize="xs"
          />
        )}
      </DropdownMenuGroup>
    </DropdownMenu>
  )
}
